import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class CLDeclarationConflictService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/CLDeclarationConflicts`);
    }
}